import React, { useState, useEffect, useRef, useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { AlertTriangle, Plus, User } from 'lucide-react';
import { getDeviceLogs, generateNewLogEntry } from '../../data/mockData';
import api from '../../services/ApiService';
import { ENDPOINTS } from '../../constant/ApiEndpoints';
import useDidFetch from '../../custom_hooks/useDidfetch';
import ManualEntryModal from './ManualEntryModal';
import toast from 'react-hot-toast';
import CheckinToolbar from './CheckinToolbar';
import { convertDateTimeTo12Hour } from '../../services/TimeFormat24hr';

const LogStatusChip = ({ status }) => {
    const statusStyles = {
        Granted: 'bg-green-100 text-green-800',
        Blocked: 'bg-red-100 text-red-800',
        Expired: 'bg-yellow-100 text-yellow-800',
        device: 'bg-yellow-100 text-yellow-800',
        manual: 'bg-red-100 text-red-800',
    };
    return <span className={`px-3 py-1 rounded-full text-sm font-medium capitalize ${statusStyles[status] || 'bg-gray-100 text-gray-800'}`}>{status}</span>;
};

const RealTimeAccessLog = () => {
    const [logs, setLogs] = useState([]);
    const [filters, setFilters] = useState({ search: '', date: ''});
    const [blockedCount, setBlockedCount] = useState(0);
    const intervalRef = useRef(null);

    const runOnce = useDidFetch();
    useEffect(() => {
        runOnce(() => {
            getAttendanceLogs();
        });
    }, []);

    const getAttendanceLogs = async () => {
        try {
            let response = await api.get(ENDPOINTS.getManualEntry);
            let result = response?.data;
            console.log(result);
            if (response?.status == 200 || response?.status == 201) {
                setLogs(result ?? []);
            }
        } catch (error) {
            console.log("getAttendanceLogs", error);
        }
    }
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [members, setMembers] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        getMembers()
    }, []);
    const handleSave = async (entryData) => {
        console.log("Manual Entry:", entryData);
        let attendanceData = {
            "member_id": entryData?.memberId,
            "entry_type": "manual",
            "device_id": '',
            "time": entryData?.timeIn,
            "notes": entryData?.notes
        }
        try {
            setIsLoading(true);
            let response = await api.post(ENDPOINTS.addManualEntry, attendanceData);
            let result = response?.data;
            if (response?.status == 200 || response?.status == 201) {
                toast.success(`Manual entry for ${entryData.memberName} saved.`);
                setIsModalOpen(false);
                getAttendanceLogs();
            }
        } catch (error) {
            console.log("handleSave", error);
        } finally {
            setIsLoading(false);
        }

    };

    const getMembers = async () => {
        try {
            setIsLoading(true);
            const response = await api.get(`${ENDPOINTS.getUserByRole}/member`);
            const result = response?.data;
            if (response.status === 200) {
                let apiuser = result?.users ?? [];
                setMembers(apiuser.filter(user => user.status == 'active'));
            }
        } catch (error) {
            console.error("getMembers error:", error);
        } finally {
            setIsLoading(false);
        }
    }


    const filteredlogs = useMemo(() => {
        console.log(filters.date);
        
        return logs.filter(log => {
            if (!filters.search && !filters.date) {
                return logs;
            }
            const searchLower = filters.search.toLowerCase();
            const nameMatch = log?.name.toLowerCase().includes(searchLower);
            const memberMatch = log?.member_id.toLowerCase().includes(searchLower);
            const dateMatch = log?.in_time.toLowerCase().includes(filters.date); 
            // const emailMatch = user.email.toLowerCase().includes(searchLower); 
            return (nameMatch) && memberMatch && dateMatch ;
        });
    }, [logs, filters]);

    return (
        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
            {/* <AnimatePresence>
                {blockedCount > 0 && (
                    <motion.div 
                        initial={{ opacity: 0, y: -20 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, height: 0, margin: 0, padding: 0 }}
                        className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg relative mb-4 flex items-center gap-3"
                    >
                        <AlertTriangle className="h-5 w-5" />
                        <span className="block sm:inline">{blockedCount} member(s) blocked due to expired plan or other issues.</span>
                        <button onClick={() => setBlockedCount(0)} className="absolute top-0 bottom-0 right-0 px-4 py-3 font-bold">&times;</button>
                    </motion.div>
                )}
            </AnimatePresence> */}
            <div className="flex items-center justify-between">
                <CheckinToolbar  filters={filters} onFilterChange={setFilters}/>
                <button
                    onClick={() => setIsModalOpen(true)}
                    className="flex items-center gap-2 px-6 py-3 bg-brand-red text-white rounded-lg hover:bg-red-600 text-sm font-medium ml-auto mb-5" >
                    <Plus size={18} /> Add Manual Entry
                </button>
            </div>
            <div className="space-y-3 max-h-[60vh] overflow-y-auto pr-2">
                <AnimatePresence initial={true}>
                    {filteredlogs.length == 0 && <div className='p-5'>No Entry Found for selected Date</div>}
                    {filteredlogs.map(log => (
                        <motion.div
                            key={log.id}
                            layout
                            initial={{ opacity: 0, y: -20, scale: 0.95 }}
                            animate={{ opacity: 1, y: 0, scale: 1 }}
                            exit={{ opacity: 0, scale: 0.95 }}
                            transition={{ duration: 0.4, type: 'spring' }}
                            className="p-4 border rounded-lg flex items-center justify-between hover:bg-gray-50"
                        >
                            <div className="flex items-center gap-4">
                                <User />
                                <div>
                                    <p className="font-bold">{log.name}</p>
                                    <p className="text-gray-600 capitalize">{log.member_id}</p> 
                                </div>
                            </div>
                            <div className="flex items-center gap-6">
                                <p className="text-sm text-gray-500 hidden sm:block">{convertDateTimeTo12Hour(log?.in_time ?? '')}</p>
                                <LogStatusChip status={log.entry_type} />
                            </div>
                        </motion.div>
                    ))}
                </AnimatePresence>
            </div>

            <ManualEntryModal
                isLoading={isLoading}
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                onSave={handleSave}
                members={members}
            />
        </div>
    );
};

export default RealTimeAccessLog;
